module.exports = __webpack_public_path__ + "d62aca321233a4496d1fdc6846b5a2cc.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/logo/full-white.svg
// module id = ./app/images/logo/full-white.svg
// module chunks = 40